import { useStore } from "zustand";

import FeatureFlagStoreContext, { TFeatureFlagStore } from "./store";
import toast from "react-hot-toast";
import { useEffect } from "react";

const isDev = import.meta.env.MODE === "development";

const useFlag = (selector: (state: TFeatureFlagStore) => any = (s) => s) =>
  useStore(FeatureFlagStoreContext, selector);

let hasBeenWarned = false;
// reactive selector
export const useFeatureFlag = (flag: string) => {
  const flags = useFlag((s) => s.flags);
  const isFeatureEnabled = flags.has(flag);
  useEffect(() => {
    if (hasBeenWarned) return;

    if (!isFeatureEnabled && isDev) {
      hasBeenWarned = true;

      toast(
        `This feature '${flag}' is disabled, but you can view it in development mode.`,
      );
    }
  }, [flag, isFeatureEnabled]);

  if (isDev) {
    return true;
  }

  return isFeatureEnabled;
};

// non-reactive selector
// Note: In development mode, this returns true for all flags (same as useFeatureFlag)
export const getFlag = (flag: string) => {
  if (isDev) {
    return true;
  }

  const flags = FeatureFlagStoreContext.getState().flags;
  return flags.has(flag);
};
